module.exports = __webpack_public_path__ + "static/media/insta.a3a1f86d.svg";